/**
 * Reconnect delays with jitter.
 *
 * After a server restart or update every open app loses its sockets at the same moment.
 * With fixed delays (1 s, 2 s, 4 s …) they all reconnect in the same instant, again and
 * again; on staging that burst pushed the server to 99 % CPU. Spreading each delay over
 * 50–150 % of its nominal value turns the burst into a steady trickle.
 */
export function jittered(ms: number, random: () => number = Math.random): number {
  return Math.round(ms * (0.5 + random()));
}
